module.exports = __webpack_public_path__ + "img/step29_switch_beam_basic-edit-1.f4eb98dc.png";